import styled from "styled-components";

export const RadioSurveyFS = styled.div`
  margin: 0.4rem;
  text-align: start;
  #labelRadioSurvey {
    margin: 0.3rem;
    text-transform: capitalize;
  }
  input {
    transform: scale(1.3);
    margin-right: 1em;
  }
`;